import BrevetLevelAsFilterButton from "../../buttons/brevetScreen/BrevetLevelAsFilterButton";

export default function BrevetLevelAsHeader({onFilterButtonClick, appliedFilters, clearFilters}) {
    // Used in

    // BUILD
    return (
        <div className={"w-full h-[64px] min-h-[64px] flex justify-end items-center space-x-[12px] px-[16px]"}>
            {/** SEARCH BAR */}
            {/*<div className={"w-[400px] min-w-[400px] h-[48px] min-h-[48px] border-[1px] border-greyLight5 bg-greyLight1 rounded-[12px] flex items-center"}>*/}
            {/*    <div className={"w-[32px] min-w-[32px] h-[32px] min-h-[32px] flex justify-center items-center bg-greyLight7"}>*/}
            {/*        <i className={"material-icons text-[16px] text-greyLight11"}>*/}
            {/*            {kSystemIcons.search}*/}
            {/*        </i>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/** FILTER BUTTON */}
            <BrevetLevelAsFilterButton onFilterButtonClick={onFilterButtonClick}
                                       appliedFilters={appliedFilters}
                                       clearFilters={clearFilters} />
        </div>
    );
}